var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.238,
    height: 16.101,
    viewBox: "0 0 63.238 16.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vipps",
    transform: "translate(-1205 -506.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M25.178,22l2.7,7.892L30.527,22h3.125L28.991,33.7h-2.33L22,22Z",
    transform: "translate(1183 484.718)",
    fill: "#ff5b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M51.056,33.4a4.874,4.874,0,0,0,4.131-2.33c.583-.741,1.324-.9,1.854-.477a1.348,1.348,0,0,1,0,1.96,7.349,7.349,0,0,1-5.985,3.231,7.958,7.958,0,0,1-6.726-4.078,1.244,1.244,0,0,1,.159-1.8,1.28,1.28,0,0,1,1.8.53A5.8,5.8,0,0,0,51.056,33.4Zm3.654-6.514A1.589,1.589,0,1,1,53.122,25.3,1.593,1.593,0,0,1,54.71,26.889Z",
    transform: "translate(1172.64 483.166)",
    fill: "#ff5b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M75.713,21.718v1.589A4.446,4.446,0,0,1,79.526,21.4c2.277,0,4.926,1.907,4.926,5.985,0,4.29-2.542,6.356-5.19,6.356a4.239,4.239,0,0,1-3.6-1.854V37.5H72.8V21.718Zm0,5.826c0,2.383,1.377,3.654,2.913,3.654,1.483,0,2.966-1.165,2.966-3.654,0-2.436-1.483-3.6-2.966-3.6S75.713,25.054,75.713,27.544Z",
    transform: "translate(1159.105 485)",
    fill: "#ff5b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M101.713,21.718v1.589a4.446,4.446,0,0,1,3.813-1.907c2.277,0,4.926,1.907,4.926,5.985,0,4.29-2.542,6.356-5.19,6.356a4.239,4.239,0,0,1-3.6-1.854V37.5H98.8V21.718Zm0,5.826c0,2.383,1.377,3.654,2.913,3.654,1.483,0,2.966-1.165,2.966-3.654,0-2.436-1.483-3.6-2.966-3.6C103.09,23.942,101.713,25.054,101.713,27.544Z",
    transform: "translate(1146.876 485)",
    fill: "#ff5b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M127.973,21.4c2.383,0,4.078,1.112,4.82,3.866l-2.6.424c-.053-1.377-.9-1.854-2.172-1.854-.953,0-1.695.424-1.695,1.112,0,.53.371,1.059,1.483,1.271l1.96.371a3.31,3.31,0,0,1,2.966,3.337c0,2.542-2.277,3.813-4.449,3.813-2.277,0-4.82-1.165-5.19-4.025l2.6-.424c.159,1.483,1.059,2.013,2.542,2.013,1.112,0,1.854-.424,1.854-1.112,0-.636-.371-1.112-1.589-1.324l-1.8-.318a3.456,3.456,0,0,1-3.072-3.39C123.683,22.512,126.066,21.4,127.973,21.4Z",
    transform: "translate(1135.446 485)",
    fill: "#ff5b24"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipps);
export default __webpack_public_path__ + "static/media/vipps.5bf64663404b84df6a1613e4e1a90927.svg";
export { ForwardRef as ReactComponent };